export default "__VITE_ASSET__69a350f2__"